import { render, staticRenderFns } from "./quotation_link.vue?vue&type=template&id=78f96c80&"
import script from "./quotation_link.vue?vue&type=script&lang=js&"
export * from "./quotation_link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports